"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandlerCheckResult = void 0;
const HandlerCheckResult = class {
    constructor(input_descriptor_path, verifiable_credential_path, evaluator, status, message, payload) {
        this.input_descriptor_path = input_descriptor_path;
        this.verifiable_credential_path = verifiable_credential_path;
        this.evaluator = evaluator;
        this.status = status;
        this.message = message;
        this.payload = payload;
    }
};
exports.HandlerCheckResult = HandlerCheckResult;
